import { OuiBoxComponent, OuiTextComponent } from '@aiz-gl/omni-ui';
import { Component, input } from '@angular/core';
import type { Region } from '../../models/region.model';

@Component({
  selector: 'app-region-tag',
  imports: [OuiBoxComponent, OuiTextComponent],
  templateUrl: './region-tag.component.html',
})
export class RegionTagComponent {
  readonly region = input.required<Region>();
}
